import { REQUEST_TYPES } from '../requestTypes';
import { ENTITY_NAMES } from '../entityNames';
import { EMPTY_OBJECT } from '../../../utils/constants';
import { ENDPOINTS } from '../../../config/config';
import { DASHBOARD_API_URLS } from '../../constants';
import { type RequestHandlerFactory } from '../../types';

const callDurationRequest =
    (entity: string): RequestHandlerFactory =>
    params => ({
        transformResponse: (res: any) => {
            const results = res?.[entity]?.data;
            return {
                entities: {
                    [entity]: {
                        items: results,
                        itemsMeta: EMPTY_OBJECT
                    }
                }
            };
        },
        descriptors: {
            [entity]: {
                method: 'post',
                defaultEndpoint: ENDPOINTS.VF_DASHBOARD_URL,
                url: DASHBOARD_API_URLS.V2.CALLS_DURATION,
                data: params
            }
        }
    });

export const callDurationStatsRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_OVERVIEW_CALL_DURATION_STATS]: callDurationRequest(ENTITY_NAMES.OVERVIEW_CALL_DURATION_STATS),
    [REQUEST_TYPES.GET_AGENCY_CALL_DURATION_STATS]: callDurationRequest(ENTITY_NAMES.AGENCY_CALL_DURATION_STATS),
    [REQUEST_TYPES.GET_OVERVIEW_AGENCY_CALL_DURATION_STATS]: callDurationRequest(
        ENTITY_NAMES.OVERVIEW_AGENCY_CALL_DURATION_STATS
    ),
    [REQUEST_TYPES.GET_OVERVIEW_AGENT_CALL_DURATION_STATS]: callDurationRequest(
        ENTITY_NAMES.OVERVIEW_AGENT_CALL_DURATION_STATS
    ),
    [REQUEST_TYPES.GET_LOCATION_CALL_DURATION_STATS]: callDurationRequest(ENTITY_NAMES.LOCATION_CALL_DURATION_STATS),
    [REQUEST_TYPES.GET_LOCATION_TEAMS_CALL_DURATION_STATS]: callDurationRequest(
        ENTITY_NAMES.LOCATION_TEAMS_CALL_DURATION_STATS
    )
};
